import { StoreUserState } from '@/types';

export default {
  user: (state: StoreUserState): any => state.loggedUser,
  userPermissionGroups: (state: StoreUserState): any =>
    state.loggedUser?.signInUserSession?.accessToken?.payload['cognito:groups'] || [],
};
